{
  "generatedAt": "2026-06-22T02:14:54.316Z",
  "userAgent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/149.0.0.0 Safari/537.36",
  "adapter": {
    "vendor": "apple",
    "architecture": "metal-3",
    "device": "",
    "description": ""
  },
  "unitsPerSecond": {
    "copyExternalImage": 14496,
    "writeBufferSmall": 2715690,
    "writeBufferBig": 10730,
    "mapAsyncWrite": 5290,
    "mapAsyncRead": 2957,
    "writeTextureSmall": 365387,
    "writeTextureBig": 43649,
    "draw": 11969060,
    "drawIndexed": 11328570,
    "drawIndirect": 6693619,
    "drawIndexedIndirect": 6551762,
    "renderBundle": 65420,
    "dispatch": 468581,
    "interleavedPasses": 15361,
    "createBindGroup": 1062998,
    "setBindGroupDynamic": 3556896,
    "setPipelineSwitch": 3589391,
    "renderPasses": 21057
  }
}
